import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

export default function UserTeamLimitDialogs({ userDetails, pendingTeamLimit,
  showTeamLimitConfirm, showRemoveTeamLimitConfirm, setShowTeamLimitConfirm,
  setShowRemoveTeamLimitConfirm, confirmSetTeamLimit, confirmRemoveTeamLimit }) {
  return (<>
      {/* Team Limit Confirmation Dialog */}
      {showTeamLimitConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <CheckCircle className="w-6 h-6 text-blue-500" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Set Custom Team Limit
                </h3>
                <p className="text-gray-600">
                  Set custom team member limit to <strong>{pendingTeamLimit}</strong> for <strong>{userDetails?.email}</strong>?
                </p>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setShowTeamLimitConfirm(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmSetTeamLimit}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
              >
                Set Limit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Remove Team Limit Confirmation Dialog */}
      {showRemoveTeamLimitConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <AlertCircle className="w-6 h-6 text-orange-500" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Remove Custom Team Limit
                </h3>
                <p className="text-gray-600">
                  Remove custom team limit for <strong>{userDetails?.email}</strong>? This will revert to plan default.
                </p>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setShowRemoveTeamLimitConfirm(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmRemoveTeamLimit}
                className="flex-1 px-4 py-2 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 transition-colors"
              >
                Remove Limit
              </button>
            </div>
          </div>
        </div>
      )}
  </>);
}
